/*
 * Skree vibe: runs after the page loads.
 *  - Swaps [data-pun="<list>"] text for a line from that pun list (shuffled, no repeats until all are seen)
 *  - Light/dark toggle buttons ([data-theme-toggle])
 *  - Paw trails (ported from skree-lab/templates/effects/paw-trails.js)
 *
 * The visit's choices (font, splash, plain or not) were made in
 * snippets/vibe-head.liquid and exposed as window.SkreeVibe.
 */
(function () {
  'use strict';

  var root = document.documentElement;
  var vibe = window.SkreeVibe || { plain: true, lists: {} };

  function pick(list) {
    return list[Math.floor(Math.random() * list.length)];
  }

  function lines(text) {
    return String(text || '')
      .split(/\r?\n/)
      .map(function (s) { return s.trim(); })
      .filter(Boolean);
  }

  /* ---------- Puns ---------- */

  /* Shuffle-bag pick: a visitor sees every line of a list once, in random order, before any
     repeat (the remaining order is kept in localStorage). Without storage it's plain random. */
  function bagPick(name, options) {
    var key = 'skree-puns-' + name;
    var bag = null;
    try { bag = JSON.parse(localStorage.getItem(key) || 'null'); } catch (e) {}
    if (!bag || bag.n !== options.length || !Array.isArray(bag.left) || !bag.left.length) {
      var left = options.map(function (_, i) { return i; });
      for (var i = left.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = left[i]; left[i] = left[j]; left[j] = t;
      }
      // Don't open a fresh round with the line that closed the last one.
      if (bag && left.length > 1 && left[left.length - 1] === bag.last) left.unshift(left.pop());
      bag = { n: options.length, left: left };
    }
    var index = bag.left.pop();
    bag.last = index;
    try { localStorage.setItem(key, JSON.stringify(bag)); } catch (e) {}
    return options[index] || pick(options);
  }

  if (vibe.puns) {
    document.querySelectorAll('[data-pun]').forEach(function (el) {
      var name = el.getAttribute('data-pun');
      var options = lines(vibe.lists[name]);
      if (options.length) el.textContent = bagPick(name, options);
    });
  }
  root.classList.remove('vibe-pending');

  /* ---------- Light / dark ---------- */

  document.querySelectorAll('[data-theme-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var next = root.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
      root.setAttribute('data-theme', next);
      try {
        localStorage.setItem('skree-theme', next);
      } catch (e) {}
    });
  });

  /* ---------- NaN Cat (1 in 9001) ---------- */
  // Rolls once per page load. ?nancat=1 forces it on previews / the theme editor; on the live
  // theme only ?nancat=<secret word from theme settings> does. The effect's code and styles
  // load only when it triggers.

  var nan = window.SkreeNanConfig;
  if (nan && nan.enabled) {
    var params = new URLSearchParams(window.location.search);
    var host = window.location.hostname;
    var theme = window.Shopify && window.Shopify.theme;
    var isPreview = nan.designMode || host === '127.0.0.1' || host === 'localhost' ||
      (theme && theme.role && theme.role !== 'main');
    var wanted = params.get('nancat');
    var launch = function () {
      var css = document.createElement('link');
      css.rel = 'stylesheet';
      css.href = nan.css;
      document.head.appendChild(css);
      var js = document.createElement('script');
      js.src = nan.js;
      js.defer = true;
      document.body.appendChild(js);
    };
    if ((wanted === '1' && isPreview) || Math.random() < 1 / Math.max(1, Number(nan.odds) || 9001)) {
      launch();
    } else if (wanted && nan.secretHash && window.crypto && crypto.subtle && window.TextEncoder) {
      // Live site: ?nancat=<secret word>, checked against the word's SHA-256 so the word isn't in the page.
      crypto.subtle.digest('SHA-256', new TextEncoder().encode(wanted.trim().toLowerCase())).then(function (buf) {
        var hex = Array.prototype.map.call(new Uint8Array(buf), function (b) { return ('0' + b.toString(16)).slice(-2); }).join('');
        if (hex === nan.secretHash) launch();
      });
    }
  }

  /* ---------- Extra effects (sparkles, confetti, color cycle) ---------- */
  // wobble / bob / rainbow are pure CSS (fx-* classes on <html>); these need a little JS.

  var fx = vibe.fx || [];
  var fxReduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (fx.indexOf('cycle') !== -1 && !vibe.plain) {
    var cycle = ['orange', 'teal', 'grape', 'coral', 'gold'];
    var ci = Math.max(0, cycle.indexOf(vibe.splash));
    setInterval(function () {
      if (document.hidden) return;
      root.classList.remove('s-' + cycle[ci]);
      ci = (ci + 1) % cycle.length;
      root.classList.add('s-' + cycle[ci]);
      vibe.splash = cycle[ci];
    }, 4000);
  }

  var wantSparkles = fx.indexOf('sparkles') !== -1;
  var wantConfetti = fx.indexOf('confetti') !== -1;
  if ((wantSparkles || wantConfetti) && !fxReduce) {
    var fxCanvas = document.createElement('canvas');
    fxCanvas.className = 'fx-canvas';
    fxCanvas.setAttribute('aria-hidden', 'true');
    document.body.appendChild(fxCanvas);
    var fctx = fxCanvas.getContext('2d');
    var FW = 0, FH = 0, fdpr = Math.min(window.devicePixelRatio || 1, 2);
    var fxResize = function () {
      FW = window.innerWidth; FH = window.innerHeight;
      fxCanvas.width = FW * fdpr; fxCanvas.height = FH * fdpr;
      fxCanvas.style.width = FW + 'px'; fxCanvas.style.height = FH + 'px';
      fctx.setTransform(fdpr, 0, 0, fdpr, 0, 0);
    };
    fxResize();
    window.addEventListener('resize', fxResize);

    var fxColors = function () {
      return root.getAttribute('data-theme') === 'dark'
        ? ['#FF3B6B', '#FF9F1C', '#FFE14D', '#3BE87A', '#2EC4FF', '#9B5CFF']
        : ['#C8264F', '#C55A00', '#A07000', '#17853F', '#1F62C4', '#7D27A6'];
    };
    var stars = [], bits = [], fxRunning = false, ft = 0;
    var LABELS = ['S', 'k', 'r', 'e', 'e', '★', '♥', '✦', '⌘', 'Fn'];

    var addBits = function (x, y, n, rain) {
      var cols = fxColors();
      for (var i = 0; i < n; i++) {
        var a = rain ? Math.PI / 2 + (Math.random() - 0.5) * 0.6 : Math.random() * Math.PI * 2;
        var sp = rain ? 1 + Math.random() * 2 : 2 + Math.random() * 5;
        bits.push({
          x: rain ? Math.random() * FW : x, y: rain ? -20 - Math.random() * 120 : y,
          vx: Math.cos(a) * sp, vy: Math.sin(a) * sp - (rain ? 0 : 2),
          r: Math.random() * Math.PI, vr: (Math.random() - 0.5) * 0.3,
          size: 10 + Math.random() * 8, life: rain ? 220 : 80 + Math.random() * 30,
          color: cols[i % cols.length], label: LABELS[Math.floor(Math.random() * LABELS.length)]
        });
      }
      startFx();
    };

    var fxFrame = function () {
      ft++;
      if (document.hidden) { fxRunning = false; return; }
      if (wantSparkles && ft % 10 === 0) {
        var cols = fxColors();
        stars.push({ x: Math.random() * FW, y: Math.random() * FH, size: 1 + Math.random() * 2, life: 0,
                     max: 50 + Math.random() * 50, color: cols[Math.floor(Math.random() * cols.length)] });
      }
      fctx.clearRect(0, 0, FW, FH);
      for (var s = stars.length - 1; s >= 0; s--) {
        var st = stars[s];
        st.life++;
        var phase = Math.sin((st.life / st.max) * Math.PI);
        var size = Math.max(1, Math.round(st.size * phase)), u = 3;
        var ax = Math.round(st.x / u) * u, ay = Math.round(st.y / u) * u;
        fctx.globalAlpha = Math.min(1, phase * 1.2) * 0.8;
        fctx.fillStyle = st.color;
        fctx.fillRect(ax - u * size, ay, u * (2 * size + 1), u);
        fctx.fillRect(ax, ay - u * size, u, u * (2 * size + 1));
        if (st.life >= st.max) stars.splice(s, 1);
      }
      for (var c = bits.length - 1; c >= 0; c--) {
        var k = bits[c];
        k.life--; k.vy += 0.12; k.x += k.vx; k.y += k.vy; k.r += k.vr;
        fctx.save();
        fctx.globalAlpha = Math.max(0, Math.min(1, k.life / 30));
        fctx.translate(k.x, k.y); fctx.rotate(k.r);
        fctx.fillStyle = k.color;
        fctx.fillRect(-k.size / 2, -k.size / 2, k.size, k.size);
        fctx.fillStyle = 'rgba(255,255,255,0.92)';
        fctx.font = 'bold ' + Math.round(k.size * 0.45) + 'px IBM Plex Mono, monospace';
        fctx.textAlign = 'center'; fctx.textBaseline = 'middle';
        fctx.fillText(k.label, 0, 0);
        fctx.restore();
        if (k.life <= 0 || k.y > FH + 30) bits.splice(c, 1);
      }
      fctx.globalAlpha = 1;
      if (wantSparkles || bits.length) requestAnimationFrame(fxFrame);
      else { fxRunning = false; fctx.clearRect(0, 0, FW, FH); }
    };
    var startFx = function () {
      if (!fxRunning) { fxRunning = true; requestAnimationFrame(fxFrame); }
    };
    document.addEventListener('visibilitychange', function () { if (!document.hidden) startFx(); });

    if (wantSparkles) startFx();
    if (wantConfetti) {
      addBits(0, 0, 45, true);
      document.addEventListener('click', function (e) {
        var target = e.target.closest && e.target.closest('.button, .pill-link, .pill-button, .pill, .icon-button');
        if (target) addBits(e.clientX, e.clientY, 18, false);
      });
    }
  }

  /* ---------- Paw trails ---------- */

  var reduceMotion = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!vibe.paws || reduceMotion) return;

  // Bright palette for dark mode; deeper, more saturated versions for light mode so paws
  // don't wash out on the pale background.
  var PALETTES = {
    dark: {
      splash: { orange: '#F29A5B', teal: '#4FB8AC', grape: '#A64BD6', coral: '#EF6F6C', gold: '#E8B33A' },
      colors: ['#F29A5B', '#4FB8AC', '#A64BD6', '#EF6F6C', '#E8B33A', '#F06AA8', '#4AA3E8', '#8CC63F',
               '#7B61FF', '#3FD0A0', '#E5484D', '#FFB020', '#D43FD1', '#2EC4D6', '#FF7A3D', '#AAA6BC'],
      opacity: [0.35, 0.6]
    },
    light: {
      splash: { orange: '#D9691E', teal: '#0F8A7E', grape: '#8A2BB0', coral: '#D2383A', gold: '#B98100' },
      colors: ['#D9691E', '#0F8A7E', '#8A2BB0', '#D2383A', '#B98100', '#D12F80', '#1F6FD1', '#4F8F14',
               '#5B3FE0', '#0B9468', '#C8262C', '#D97A00', '#AE1FAC', '#0E879C', '#E2520F', '#3C3F52'],
      opacity: [0.6, 0.9]
    }
  };
  var cfg = {
    pawsPerTrail: 7,
    interval: 700,
    initialBurst: 5,
    maxTrails: 16,
    minSize: 28,
    maxSize: 48,
    fadeInMs: 600,
    staggerMs: 300,
    visibleMs: 2000,
    visibleJitter: 600,
    splashBias: 0.3
  };

  var field = document.createElement('div');
  field.className = 'paw-field';
  field.setAttribute('aria-hidden', 'true');
  document.body.appendChild(field);

  var SVG_NS = 'http://www.w3.org/2000/svg';
  // Cat paw print: a wide main pad with a three-lobed bottom and four oval toes in an arc,
  // outer toes set lower and angled outward. Toes point "up", the direction of travel.
  var PAW_SHAPES = [
    ['path', { d: 'M16 13.6c-3.6 0-6 3.2-7.4 6.1-1.3 2.6-.6 5.9 2.5 6.3 1.8.2 3.2-.7 4.9-.7s3.1.9 4.9.7c3.1-.4 3.8-3.7 2.5-6.3-1.4-2.9-3.8-6.1-7.4-6.1z' }],
    ['ellipse', { cx: 7.3, cy: 12.9, rx: 2.5, ry: 3.3, transform: 'rotate(-28 7.3 12.9)' }],
    ['ellipse', { cx: 12.3, cy: 7.9, rx: 2.6, ry: 3.5, transform: 'rotate(-9 12.3 7.9)' }],
    ['ellipse', { cx: 19.7, cy: 7.9, rx: 2.6, ry: 3.5, transform: 'rotate(9 19.7 7.9)' }],
    ['ellipse', { cx: 24.7, cy: 12.9, rx: 2.5, ry: 3.3, transform: 'rotate(28 24.7 12.9)' }]
  ];

  function makePaw(colour, size) {
    var svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('width', size);
    svg.setAttribute('height', size);
    svg.setAttribute('viewBox', '0 0 32 32');
    svg.setAttribute('fill', colour);
    PAW_SHAPES.forEach(function (shape) {
      var el = document.createElementNS(SVG_NS, shape[0]);
      Object.keys(shape[1]).forEach(function (k) { el.setAttribute(k, shape[1][k]); });
      svg.appendChild(el);
    });
    return svg;
  }


  function palette() {
    return PALETTES[root.getAttribute('data-theme') === 'dark' ? 'dark' : 'light'];
  }

  function pawColour(pal) {
    return Math.random() < cfg.splashBias && pal.splash[vibe.splash] ? pal.splash[vibe.splash] : pick(pal.colors);
  }

  function spawnTrail() {
    if (document.hidden || field.childElementCount >= cfg.maxTrails) return;

    var trail = document.createElement('div');
    trail.className = 'paw-trail';

    var count = cfg.pawsPerTrail;
    var pal = palette();
    var size = cfg.minSize + Math.random() * (cfg.maxSize - cfg.minSize);
    var stepY = size * (1.55 + Math.random() * 0.35);
    var zig = size * (0.45 + Math.random() * 0.2);

    trail.style.left = 100 + Math.random() * Math.max(0, window.innerWidth - 200) + 'px';
    trail.style.top = 120 + Math.random() * Math.max(0, window.innerHeight - 160) + 'px';
    trail.style.transform = 'rotate(' + Math.random() * 360 + 'deg)';

    var lifetime = 0;
    for (var i = 0; i < count; i++) {
      var paw = document.createElement('div');
      paw.className = 'paw-trail__paw';
      var side = i % 2 === 0 ? -1 : 1;
      var x = side * zig * (0.85 + Math.random() * 0.3);
      var rot = side * 8 + (Math.random() - 0.5) * 6;
      paw.style.left = x + 'px';
      paw.style.top = -i * stepY + 'px';
      paw.style.transform = 'rotate(' + rot + 'deg)';
      paw.style.transitionDuration = cfg.fadeInMs + 'ms';
      paw.appendChild(makePaw(pawColour(pal), size));
      trail.appendChild(paw);

      var showAt = i * cfg.staggerMs + 100;
      var hideAt = i * cfg.staggerMs + cfg.visibleMs + Math.random() * cfg.visibleJitter;
      lifetime = Math.max(lifetime, hideAt);
      (function (p, op) {
        setTimeout(function () { p.style.opacity = op; }, showAt);
      })(paw, (pal.opacity[0] + Math.random() * (pal.opacity[1] - pal.opacity[0])).toFixed(2));
      (function (p) {
        setTimeout(function () { p.style.opacity = '0'; }, hideAt);
      })(paw);
    }

    field.appendChild(trail);
    setTimeout(function () { trail.remove(); }, lifetime + cfg.fadeInMs + 200);
  }

  for (var b = 0; b < cfg.initialBurst; b++) setTimeout(spawnTrail, b * 300);
  setInterval(spawnTrail, cfg.interval);
})();
